module.exports = __webpack_public_path__ + "static/media/update.14f4efcd.svg";